// @ts-nocheck
import type { SVGProps } from "react";
import { Users } from "lucide-react";

export function UsersIcon(props: SVGProps<SVGSVGElement>) {
  return <Users color="currentColor" {...props} className={`w-5 h-5 ${props.className ?? ""}`} />;
}
